import React from 'react'
import { connect } from 'react-redux'
import imgFeatureList1 from '../../images/public/object-group.png'
import imgFeatureList2 from '../../images/public/chart-line.png'
import imgFeatureList3 from '../../images/public/shield-alt.png'
import Header from '../partials/Header.jsx'
import Footer from '../partials/Footer.jsx'
import SupportList from '../partials/SupportList.jsx'
import CallToActRegister from '../partials/CallToActRegister.jsx'
import BlogList from '../partials/BlogList.jsx'

class ArticlesPartners extends React.Component {
	componentDidMount() {
		window.scrollTo(0, 0)
	}

  render() {

    return (
			<main>
      <section className="homepage-feature">
				<Header isNavbarFixed={true} />
				<div className="homepage-feature-list bg-partners">
          <div className="container">
            <h2 className="heading1 m-b-76">Astronaut for Partners via API</h2>
            <div className="flex flex-around">
              <div className="feature-list-item">
                <div className="feature-list-image">
									<img src={imgFeatureList1} alt="Leverage central dashboard" />
                </div>
                <div className="heading4 bold">
									LEVERAGE CENTRAL <br />DASHBOARD
                </div>
              </div>
              <div className="feature-list-item">
                <div className="feature-list-image">
									<img src={imgFeatureList2} alt="Bring more value" />
								</div>
                <div className="heading4 bold">
                  BRING MORE VALUE
                </div>
              </div>
              <div className="feature-list-item">
                <div className="feature-list-image">
									<img src={imgFeatureList3} alt="Differentiate and future-proof" />
								</div>
                <div className="heading4 bold">
									DIFFERENTIATE & <br />FUTURE-PROOF
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
			<section className="article-page-title">
				<div className="heading2">Case Study</div>
				<div className="heading1 larger">Contact us for more details.</div>
			</section>
      <SupportList />
      <CallToActRegister />
			<BlogList />
      <Footer />
    </main>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
	return {
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ArticlesPartners)
